import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { FitnessGoalsDataService, FitnessGoalsColumnsService } from '../../../services';
import { FitnessGoal, FitnessGoalsResult } from '../../../interfaces';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-fitness-goal-form',
  templateUrl: './fitness-goal-form.component.html',
  styleUrls: ['./fitness-goal-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class FitnessGoalFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public fitnessGoal: FitnessGoal = {};
  public fitnessGoalForm: FormGroup = new FormGroup({});
  public fitnessGoals: FitnessGoal[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;

  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private fitnessGoalsDataService: FitnessGoalsDataService,
    public fitnessGoalsColumnsService: FitnessGoalsColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'FitnessGoalFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Fitness Goal - Edit');
        this.getFitnessGoal(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.fitnessGoal !== 'undefined') {
      this.fitnessGoal = this.dynamicDialogConfig.data.fitnessGoal;
    }
    if (typeof this.fitnessGoal.id === 'undefined' || this.fitnessGoal.id === null) {
      this.fitnessGoal.id = null;
      this.fitnessGoal.isPublished = false;
    }
    this.getFitnessGoals();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'FitnessGoalFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'FitnessGoalFormComponent');
  }

  getFitnessGoal(id: number): void {
    this.isLoading = true;
    this.fitnessGoalsDataService.getFitnessGoal(id).subscribe((response: FitnessGoal|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.fitnessGoal = response;
        this.prepareFrom();
      }
    });
  }

  getFitnessGoals(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.fitnessGoals !== 'undefined' && this.dynamicDialogConfig.data.fitnessGoals.length > 0) {
      this.fitnessGoals = this.dynamicDialogConfig.data.fitnessGoals;
      return;
    }
    this.fitnessGoalsDataService.getFitnessGoals(this.parameters).subscribe((response: FitnessGoalsResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.fitnessGoals = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.fitnessGoalForm = new FormGroup({
      id: new FormControl(this.fitnessGoal.id, []),
      name: new FormControl(this.fitnessGoal.name, [Validators.required, ]),
      nameAr: new FormControl(this.fitnessGoal.nameAr, []),
      nameFr: new FormControl(this.fitnessGoal.nameFr, []),
      description: new FormControl(this.fitnessGoal.description, []),
      descriptionAr: new FormControl(this.fitnessGoal.descriptionAr, []),
      descriptionFr: new FormControl(this.fitnessGoal.descriptionFr, []),
      longDescription: new FormControl(this.fitnessGoal.longDescription, []),
      longDescriptionAr: new FormControl(this.fitnessGoal.longDescriptionAr, []),
      longDescriptionFr: new FormControl(this.fitnessGoal.longDescriptionFr, []),
      icon: new FormControl(this.fitnessGoal.icon, []),
      picture: new FormControl(this.fitnessGoal.picture, []),
      isPublished: new FormControl(this.fitnessGoal.isPublished, [Validators.required, ]),
    });
  }

  list() {
    this.router.navigate(['/fitness-goals']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.fitnessGoalForm.controls).forEach((field: any) => {
        const control = this.fitnessGoalForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.fitnessGoalForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.fitnessGoal = this.fitnessGoalForm.value;
    this.disableSubmit = true;
    console.log('fitnessGoal', this.fitnessGoal);
    if (typeof this.fitnessGoal.id !== 'undefined' && this.fitnessGoal.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.fitnessGoalsDataService.updateFitnessGoal(this.fitnessGoal).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('FITNESSGOALUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('FITNESSGOALNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.fitnessGoalsDataService.addFitnessGoal(this.fitnessGoal).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('FITNESSGOALCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('FITNESSGOALNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.fitnessGoalForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'fitness-goals',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.fitnessGoalForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-fitness-goal-form',
  templateUrl: './fitness-goal-form.component.html',
  styleUrls: ['./fitness-goal-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogFitnessGoalFormComponent extends FitnessGoalFormComponent {
}

